import { render, staticRenderFns } from "./housePriceIndexTable.vue?vue&type=template&id=d05479f6"
import script from "./housePriceIndexTable.vue?vue&type=script&lang=js"
export * from "./housePriceIndexTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports